import CheckoutCartSuccess from './CheckoutCartSuccess';
import withModal from '../../../../components/global/modal/withModal';

export const CHECKOUT_CART_SUCCESS_MODAL = 'CHECKOUT_CART_SUCCESS_MODAL';

export default withModal(CheckoutCartSuccess, {
  name: CHECKOUT_CART_SUCCESS_MODAL,
  size: 'sm',
  type: 'full',
  hideHeader: true,
  dismissible: false,
  shouldCloseOnOverlayClick: false,
  className: 'modal-contained memberships-checkout-success-modal',
});
